define('Extended.ItemRelations.RelatedItem.View'
    , [
        'ItemRelations.RelatedItem.View'

        , 'extended_item_relations_related_item.tpl'
    ]
    , function (
        ItemRelationsRelatedItemView

        , extended_item_relations_related_item_tpl
    ) {
        'use strict';

        return ItemRelationsRelatedItemView.extend({
            template: extended_item_relations_related_item_tpl
        });
    });
